import "./FlatteningHeader.css"

import React from "react"
import { useNavigate } from "react-router-dom"

import KintoEmblem from "../../assets/kinto_emblem.svg"
import LogoKintoBrasil from "../../assets/LogoKintoBrasil.svg"

type OwnProps = {
  flattened?: boolean
}

const FlatteningHeader = (props: OwnProps): React.ReactElement => {
  const navigate = useNavigate()

  return (
    <>
      <img src={KintoEmblem} alt="Kinto Emblem" className={"kinto-emblem " + (props.flattened ? "emblem-to-corner hide" : "emblem-to-center appear")} id="kinto-emblem" />
      <div className={"bg-header " + (props.flattened ? "bg-header-flat" : "bg-header-open")} id="background-header">
        <img src={LogoKintoBrasil} alt="Logo Kinto Brazil" className={"clickable kinto-logo " + (props.flattened ? "appear" : "hide")} id="kinto-logo" onClick={() => { navigate("/", { replace: true }) }}/>
      </div>
    </>
  )
}

export default FlatteningHeader
